var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.176em",
    height: "1em",
    viewBox: "0 0 20 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.082 15.844h0L2.213 8.977v-.001A5.066 5.066 0 01.75 5.346v-.005A4.626 4.626 0 015.423.751h.015a4.626 4.626 0 013.334 1.37h0l.003.004.667.667.53.53.53-.53.548-.547h0l.007-.007a4.846 4.846 0 016.347-.519 4.752 4.752 0 011.544 5.431l.702.264-.702-.264a4.751 4.751 0 01-1.083 1.684s0 0 0 0l-7.003 7.01h0a1.252 1.252 0 01-.888.367H9.97a1.25 1.25 0 01-.888-.367z",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}

export default SvgHeart;